
import {  FaInstagram } from 'react-icons/fa';
import { Link } from "react-router-dom";
function Footer () {
    return(
<footer className="bg-beige text-brown">
         <div className="max-w-6xl mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          
          <p className="text-sm text-bold">
            © {new Date().getFullYear()} Studio CLAIRÉ AB
          </p>
          <p className="text-sm font-bold">
            Centralgatan 17
            852 32
            Sundsvall
            </p>
          <nav className="flex gap-6 text-sm">
          <Link to="/tjanster" className="hover:text-brown-dark transition">Tjänster</Link> 
          <Link to="/omoss" className="hover:text-brown-dark transition">Om oss</Link> 
          <Link to="/kontakt" className="hover:text-brown-dark transition">Kontakt</Link> 

          </nav>
           <nav className="flex gap-6 text-sm">
                      <Link to="/bokningsvillkor" className="hover:text-brown-dark transition">Bokningsvillkor</Link> 
          <Link to="/integritetspolicy" className="hover:text-brown-dark transition">Integritetspolicy</Link> 
           </nav>
 <div className="flex gap-4 text-xl">
          {/* <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-brown/70 bg-beige-dark p-1 rounded rounded-lg">
            <FaFacebookF />
          </a> */}
          <a href="https://www.instagram.com/claire.sundsvall/" target="_blank" rel="noopener noreferrer" className="hover:text-brown/70 bg-beige-dark p-1 rounded rounded-lg">
            <FaInstagram />
          </a>
        </div>


        </div>
      </div>

</footer>
    );
}

export default Footer;